import mergeRefs from 'merge-refs';
import { forwardRef, useRef, useState } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Modal, { type ModalAction } from '@/components/common/modal/modal';

import FormInput from '../form-input';

interface Props {
  title: string;
  onSubmit: (data: { modalInputValue: string }) => Promise<void> | void;
  defaultValue?: string;
  placeholder?: string;
}

const InputModal = forwardRef<ModalAction, Props>(({ onSubmit, title, defaultValue, placeholder }, ref) => {
  const { handleSubmit, control } = useForm<{ modalInputValue: string }>({
    defaultValues: { modalInputValue: defaultValue },
  });
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { modalInputValue } = useWatch({ control });
  const modalRef = useRef<ModalAction>(null);
  return (
    <Modal
      ref={mergeRefs(modalRef, ref)}
      defaultOpen={false}
      className=''
      clickOutsideToClose
      onClose={() => modalRef.current?.close()}
      contentClassName='w-fit rounded-none bg-white p-6 rounded-2xl'>
      <form
        onSubmit={handleSubmit(async (data) => {
          setIsLoading(true);
          await onSubmit(data);
          setIsLoading(false);
          modalRef.current?.close();
        })}
        className='flex flex-col gap-y-4'>
        <div className='text-base font-bold'>{title}</div>
        <FormInput
          control={control}
          name='modalInputValue'
          defaultValue={defaultValue ?? ''}
          showClearButton
          required
          placeholder={placeholder}
        />
        <div className='flex justify-end gap-2'>
          <button
            className='btn h-10 min-h-10 font-normal btn-ghost order-first'
            type='button'
            onClick={() => modalRef.current?.close()}>
            {t('common.cancel')}
          </button>
          <button
            className='btn h-10 min-h-10 font-normal btn-primary '
            type='submit'
            disabled={!modalInputValue || isLoading}>
            {isLoading ? <span className='loading loading-spinner loading-sm' /> : t('common.confirm')}
          </button>
        </div>
      </form>
    </Modal>
  );
});

export default InputModal;
